import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { EASE } from "./Reveal";

const links = [
  { href: "#piemeri", label: "Piemēri" },
  { href: "#problems", label: "Problēma" },
  { href: "#sistema", label: "Sistēma" },
  { href: "#kriteriji", label: "Kritēriji" },
];

export const scrollToSection = (href) => {
  if (window.__lenis) window.__lenis.scrollTo(href, { offset: -72 });
  else document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
};

export default function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -90 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.9, delay: 0.2, ease: EASE }}
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 border-b transition-colors duration-500 ${
        scrolled ? "bg-white/85 backdrop-blur-xl border-black/10" : "bg-white/60 backdrop-blur-md border-black/5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-[72px] flex items-center justify-between">
        <a
          href="#top"
          data-testid="header-logo"
          onClick={(e) => { e.preventDefault(); scrollToSection("#top"); }}
          className="flex items-center gap-3"
        >
          <img src="/assets/im_logo.svg" alt="iMarketings.lv" className="h-9 w-9 rounded-full" />
          <span className="font-display font-bold tracking-tight text-lg text-[#003E75]">
            iMarketings<span className="text-[#ED1C27]">.lv</span>
          </span>
        </a>
        <nav className="hidden md:flex items-center gap-8" data-testid="header-nav">
          {links.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-${l.href.slice(1)}`}
              onClick={() => scrollToSection(l.href)}
              className="text-sm font-medium text-[#003E75]/55 hover:text-[#003E75] transition-colors duration-300 tracking-wide"
            >
              {l.label}
            </button>
          ))}
        </nav>
        <button
          data-testid="header-cta-button"
          onClick={() => scrollToSection("#pieteikties")}
          className="group flex items-center gap-2 bg-[#ED1C27] text-white text-sm font-semibold pl-5 pr-4 py-2.5 rounded-full hover:scale-105 transition-transform duration-300"
        >
          Bezmaksas audits
          <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:rotate-45" />
        </button>
      </div>
    </motion.header>
  );
}
